import Tool from '../../../tools/Tool';
import EmojiPickerSubmenu from '../components/EmojiPickerSubmenu';

class ToolInsertEmoji extends Tool {
  static toolName = 'Emoji';
  static iconClass = 'fa-regular fa-face-smile';

  static toolbarSubmenu() {
    return EmojiPickerSubmenu;
  }
}

export default ToolInsertEmoji;
